import { useState, useEffect, useContext } from "react";
import { LanguageContext } from "../../../context/LanguageContext";

export default function Faq() {
  const { t, isRTL } = useContext(LanguageContext);
  const [open, setOpen] = useState(null);

  const sections = t("faqPage.sections", { returnObjects: true });

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <main
      dir={isRTL ? "rtl" : "ltr"}
      className="bg-gray-50 py-24"
    >
      <div className="mx-auto max-w-4xl px-6">

        <h1 className="text-center text-4xl font-bold text-gray-900">
          {t("faqPage.title")}
        </h1>

        <p className="mt-4 text-center text-gray-600">
          {t("faqPage.subtitle")}
        </p>

        <div className="mt-16 space-y-12">
          {sections.map((section, i) => (
            <div key={i}>
              <h2 className="mb-6 text-2xl font-semibold text-gray-900">
                {section.title}
              </h2>

              <div className="space-y-4">
                {section.items.map((item, j) => {
                  const index = `${i}-${j}`;
                  const isOpen = open === index;

                  return (
                    <div
                      key={index}
                      className="rounded-xl border bg-white shadow-sm"
                    >
                      <button
                        onClick={() => setOpen(isOpen ? null : index)}
                        className="flex w-full items-center justify-between px-6 py-4 text-left font-medium text-gray-800"
                      >
                        {item.q}
                        <span>{isOpen ? "−" : "+"}</span>
                      </button>

                      {isOpen && (
                        <div className="px-6 pb-4 text-gray-600">
                          {item.a}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>

      </div>
    </main>
  );
}
